import validate from "/workspace/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45guard_45global from "/workspace/frontend/middleware/authGuard.global.ts";
import layout_45guard_45global from "/workspace/frontend/middleware/layoutGuard.global.ts";
import subscription_45guard_45global from "/workspace/frontend/middleware/subscriptionGuard.global.ts";
import zz_45member_45access_45global from "/workspace/frontend/middleware/zzMemberAccess.global.ts";
import manifest_45route_45rule from "/workspace/frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45guard_45global,
  layout_45guard_45global,
  subscription_45guard_45global,
  zz_45member_45access_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "global-talent-advisor": () => import("/workspace/frontend/middleware/globalTalentAdvisor.ts")
}